import { StateSetter, createContext, useContext } from 'react';

import { LoadedPackage } from './types';

interface PackageContextData {
  loading: boolean;
  data: LoadedPackage;
  overwrite: StateSetter<LoadedPackage>;
  reload: () => void;
}

const PackageContext = createContext<PackageContextData>({} as PackageContextData);

function usePackage(): PackageContextData {
  const context = useContext(PackageContext);

  if (!context.overwrite) {
    throw new Error('usePackage must be used within a PackageProvider');
  }

  return context;
}

export { PackageContext, usePackage };
